function attachJobFormValidation(form) {
  if (!form || form.dataset.validationAttached === "true") return;

  form.dataset.validationAttached = "true";

  var phoneInput = form.querySelector("input[name='job[contact_phone]']");

  phoneInput.addEventListener('input', () => {
    checkPhoneValidation(phoneInput);

    if (!phoneInput.checkValidity()) {
      phoneInput.classList.add('is-invalid');
      phoneInput.classList.remove('is-valid');
    } else {
      phoneInput.classList.remove('is-invalid');
      phoneInput.classList.add('is-valid');
    }
  });

  form.addEventListener('submit', function(event) {
    checkPhoneValidation(phoneInput);

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();

      checkRadioValidity(form.querySelector("input[name='job[starting]']"));
      checkRadioValidity(form.querySelector("input[name='job[preferred_outcome]']"));
      toggleSuburbInvalidFeedback();

      $('.js-clear_field').attr('disabled', 'disabled');
    }

    form.classList.add('was-validated');
  });
}

$(function () {
  const form = document.getElementById('jobForm');
  attachJobFormValidation(form);
});

function checkPhoneValidation(phoneInput) {
  const phone = phoneInput.value.trim();
  const phoneRegex = /^(?!1300|1800)(0[23478])\d{8}$/;

  const invalidFeedbackElement = phoneInput.closest('.form-group').querySelector('.invalid-feedback');

  if (phone === "") {
    phoneInput.setCustomValidity("This field is required");
    invalidFeedbackElement.textContent = "Enter a contact phone";
    invalidFeedbackElement.style.display = 'block';
  } else if (!phoneRegex.test(phone)) {
    phoneInput.setCustomValidity("Invalid phone number format");
    invalidFeedbackElement.textContent = "Enter a valid phone number (10 digits, no 1300 or 1800)";
    invalidFeedbackElement.style.display = 'block';
  } else {
    phoneInput.setCustomValidity("");
    invalidFeedbackElement.style.display = 'none';
  }
}

function checkRadioValidity(radioButton) {
  if (radioButton.checkValidity() === false) {
    radioButton.parentNode.parentNode.classList.add('group-invalid');
  } else {
    radioButton.parentNode.parentNode.classList.remove('group-invalid');
  }
}

function toggleSuburbInvalidFeedback() {
  $('#job_suburb_name:invalid').parent('.easy-autocomplete').siblings('.invalid-feedback').show()
  $('#job_suburb_name:valid').parent('.easy-autocomplete').siblings('.invalid-feedback').hide()

  $('#job_suburb_id:invalid').siblings('.invalid-feedback').show()
  $('#job_suburb_id:valid').siblings('.invalid-feedback').hide()
}
